import {apiClient, getRequest, postRequest} from "./AxiosConfig";

export async function getTermsPaged(page, setErrorMessage) {
    return await getRequest( `/term/all/${page}`, setErrorMessage);
}

export async function getTermsByCourse(courseId, page, setErrorMessage) {
    return await getRequest( `/term/${courseId}/${page}`, setErrorMessage);
}

export async function getFlashcardsByCourse(courseId, setErrorMessage) {
    return await getRequest( `/term/${courseId}/flashcards`, setErrorMessage);
}

export async function getTermsByCourseAndKeyword(courseId, page, keyword, setErrorMessage) {
    return await getRequest( `/term/${courseId}/${page}/${keyword}`, setErrorMessage);
}

export async function updateTerm(term, setErrorMessage) {
    return await postRequest( "/term/update", setErrorMessage, term);
}
